import { css } from 'styled-components';
import { colors } from 'globalStyles';

const buttonStyles = css`
  padding: 0.8em 1.5em;
  background-color: ${colors.MAIN_COLOR};
  border-radius: 3px;
  color: ${colors.WHITE};
  font-size: 12px;
  font-weight: bold;
  line-height: 17px;
  transition: all .4s ease;

  background: ${colors.BUTTON_BG};

  &:hover:not(:disabled), &:active:not(:disabled) {
    background-color: lighten(${colors.MAIN_COLOR}, 5%);
  }

  &:disabled {
    background: var(--button-disabled);
    color: var(--button-disabled-foreground);
    cursor: not-allowed;
  }

  &.active,
  &:hover:not(:disabled),
  &:active:not(:disabled) {
    background: ${colors.WHITE};
    border: 1px solid ${colors.MAIN_COLOR};
    color: ${colors.MAIN_COLOR};
  }
`;

export default buttonStyles;
